var _rect, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Google Drive",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ffffff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2684fc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M337 301l53 96q-3 2-10 2h-247.6 q-6 0-10-2l55-95"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ea4335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M335 301l55 96q6-3 10-10l43-76q2-6 2-10"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(120 256 256)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#b",
    fill: "#00ac47"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#c",
    fill: "#0066da"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(240 256 256)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#b",
    fill: "#ffba00"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#c",
    fill: "#00832d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.c76c83197703904230a4a72bbe1667ad.svg";
export { ForwardRef as ReactComponent };